import { styled } from '@mui/system'
import { colors } from '../../../../Components/consts'

export const ListOuterCon = styled('div')(({ theme }) => ({
  padding: theme.spacing(1),
  background: colors.white,
}))

export const ListCon = styled('div')(({ theme }) => ({
  margin: theme.spacing(1, 4),
  background: colors.white,
  [theme.breakpoints.between('sm', 'md')]: {
    margin: theme.spacing(1, 2),
  },
  '& .table': {
    width: '100%',
    borderCollapse: 'collapse',
    '& thead': {
      position: 'sticky',
      top: 0,
      zIndex: 20,
      background: colors.white,
      borderBottom: `1px solid ${colors.lightestGrey}`,
    },
    '& th': {
      fontSize: 10,
      color: colors.text,
      fontWeight: 600,
      textTransform: 'uppercase',
      height: theme.spacing(3),
      width: 'auto',
      textAlign: 'left',
    },
    '& tbody tr': {
      borderTop: `1px solid ${colors.lightestGrey}`,
      '&:first-of-type': {
        borderTop: 0,
      },
    },

    '& tbody td': {
      fontSize: 16,
      padding: theme.spacing(0.5),
      color: colors.text,
      height: 40,
      textAlign: 'left',
      fontWeight: 600,
      verticalAlign: 'middle',
      [theme.breakpoints.between('sm', 'md')]: {
        fontSize: 14,
      },
      [theme.breakpoints.down('sm')]: {
        padding: theme.spacing(0.25),
        fontSize: 11,
      },
      '&:first-of-type': {
        width: '20%',
      },
      '&:nth-of-type(2)': {
        width: '60%',
      },
      '&:nth-of-type(4)': {
        width: '20%',
      },
    },
  },
}))

export const Broadcaster = styled('img')(({ theme }) => ({
  display: 'inline-block',
  width: 70,
  margin: '2px 3px 2px 2px',
  [theme.breakpoints.down('sm')]: {
    width: 50,
  },
  [theme.breakpoints.down('xs')]: {
    width: 45,
  },
}))

export const TeamCell = styled('div')(({ theme }) => ({
  display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    '& .results': {
      fontSize: 18,
      margin: 5,
      color: colors.text,
      textAlign: 'left',
      fontWeight: 600,
      [theme.breakpoints.between('sm', 'md')]: {
        fontSize: 14,
      },
      [theme.breakpoints.down('sm')]: {
        margin: 3,
        fontSize: 11,
      },
    },
    '& .status': {
      fontSize: 12,
      margin: 2,
      color: colors.green,
      textAlign: 'center',
      fontWeight: 600,
      [theme.breakpoints.between('sm', 'md')]: {
        fontSize: 10,
      },
      [theme.breakpoints.down('sm')]: {
        padding: theme.spacing(0.5, 1),
        fontSize: 8,
      },
    },
}))
